// extracted by mini-css-extract-plugin
export default {"link":"bannerCard_link__gd4jp","img":"bannerCard_img__b6uzO"};